export const errorCodes = {
    USER_NOT_LOGGED_IN: "CODE_ERROR_APP:1-3",
    SPENDING_DEMAND_NO_TEAM_COMPTA_FOUND: "code:SD01"
}